import { BreadcrumbList, WithContext } from 'schema-dts';

import { DEFAULT_STRUCTURE } from '../constants';
import { createListItem, ItemListingParams } from './itemListing';

export const breadcrumbsMapper = ({
  items,
}: ItemListingParams): WithContext<BreadcrumbList> => ({
  ...DEFAULT_STRUCTURE,
  '@type': 'BreadcrumbList' as const,
  itemListElement: items.map((item, index) =>
    createListItem({ ...item, position: index + 1 })
  ),
});
